import { CheckCircle2 } from "lucide-react";

interface VerifiedFieldCardProps {
  fieldLabel: string;
  currentValue: string;
}

export function VerifiedFieldCard({
  fieldLabel,
  currentValue,
}: VerifiedFieldCardProps) {
  return (
    <div className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-blue-50/50 to-blue-100/30 rounded-lg" />
      <div className="relative bg-white/90 backdrop-blur-sm rounded-lg p-4 border border-blue-100/50">
        <div className="flex items-center space-x-3">
          <div className="flex-shrink-0">
            <div className="relative">
              <div className="absolute inset-0 bg-blue-400 rounded-full blur-sm opacity-20 animate-pulse motion-reduce:animate-none" />
              <CheckCircle2 className="relative w-5 h-5 text-blue-600" />
            </div>
          </div>
          <div className="flex-grow">
            <p className="text-sm text-gray-700 font-light leading-relaxed">
              <span className="text-blue-700 font-medium">Verificado:</span>{" "}
              {fieldLabel.toLowerCase()} permanece{" "}
              <span className="font-semibold text-gray-800 bg-blue-50 px-2 py-0.5 rounded-md">
                {currentValue}
              </span>
            </p>
            <p className="text-xs text-blue-600/70 mt-1 font-light">
              Dados atualizados e confirmados
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
